// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-wrap[data-v-204b0ef0]{flex-wrap:wrap}.flex-c-s[data-v-204b0ef0]{display:flex;justify-content:flex-start;align-items:center}.info-box[data-v-204b0ef0]{padding:0 20px}.info-box .row[data-v-204b0ef0]{width:50%;margin-top:32px}.info-box .row .field[data-v-204b0ef0]{width:144px;font-size:16px;color:#666;line-height:18px}.info-box .row .value[data-v-204b0ef0]{font-size:16px;color:#333;line-height:18px}", ""]);
// Exports
module.exports = exports;
